
import { LogWriter } from "./log-writter";
import { Severity } from './models/severity.enum'
import { LogEntry } from "./models/log-entry.model";
import { Injectable } from "@angular/core";
import { LoggingService } from "./logging.service";

/**
 * Use this writer to log information to the browser console.
 */
@Injectable()
export class ConsoleWriter extends LogWriter {

  constructor(
    private loggingService: LoggingService
  ) {
    super();
    this.loggingService.logEntries$.subscribe(
      logEntry => this.handleLogEntry(logEntry)
    );
  }

  handleLogEntry(logEntry: LogEntry) {
    this.targetEntry = logEntry;
    this.writeToLog();
  }


  /**
   * Implementation of the abstract method. This will perform the
   * actual `write` action for the specified writer.
   */
  public writeToLog(): void {
    switch (this.targetEntry.severity) {
      case Severity.Debug:
        console.debug(this.targetEntry);
        break;
      case Severity.Info:
        console.info(this.targetEntry);
        break;
      case Severity.Warn:
        console.warn(this.targetEntry);
        break;
      case Severity.Error:
        console.error(this.targetEntry);
        break;
      case Severity.Trace:
        console.debug(this.targetEntry);
        break;
      default:
        break;
    }
  }
}
